import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";

export default function ExchangeAdmin() {
  const [rates, setRates] = useState([]);
  const load = () => api.get("/exchange-rates").then(({ data }) => setRates(data.sort((a, b) => a.currency.localeCompare(b.currency))));
  useEffect(() => { load(); }, []);

  const setVal = (currency, per_usd) => setRates((rs) => rs.map((r) => r.currency === currency ? { ...r, per_usd } : r));
  const save = async (r) => {
    await api.put(`/exchange-rates/${r.currency}`, { currency: r.currency, per_usd: Number(r.per_usd) });
    toast.success(`${r.currency} rate updated`);
    load();
  };

  return (
    <div className="max-w-2xl">
      <p className="text-sm text-muted-foreground mb-4">Set units of each currency per <span className="font-mono-data text-navy">1 USD</span>. Used for cost estimation and conversion. Currency conversion is for estimation purposes only.</p>
      <div className="border border-border rounded-md overflow-hidden">
        {rates.map((r) => (
          <div key={r.currency} className="flex items-center gap-4 px-5 py-3 border-b border-border last:border-0" data-testid={`fx-row-${r.currency}`}>
            <div className="font-mono-data font-bold text-navy w-16">{r.currency}</div>
            <span className="text-sm text-muted-foreground">1 USD =</span>
            <Input type="number" value={r.per_usd} onChange={(e) => setVal(r.currency, e.target.value)} className="rounded-sm font-mono-data w-40" disabled={r.currency === "USD"} data-testid={`fx-input-${r.currency}`} />
            <Button size="sm" variant="outline" className="rounded-sm ml-auto" onClick={() => save(r)} disabled={r.currency === "USD"} data-testid={`fx-save-${r.currency}`}><Save className="h-4 w-4 mr-1.5" />Save</Button>
          </div>
        ))}
      </div>
    </div>
  );
}
